/**
 * Collection Page Tour Configuration
 * Guided tour for personal favorites management
 */

export const COLLECTION_TOUR_STEPS = [
  {
    id: 'welcome',
    title: 'Your Personal Collection ⭐',
    description: 'Quick access to all your favorited tools in one place - like your personal AI toolbox!',
    position: 'center'
  },
  {
    id: 'star-vs-bookmark',
    title: 'Collection vs Bookmarks',
    description: 'Star (⭐) adds to this Collection page for browsing. Bookmark (🔖) pins to sidebar for instant access. Use both strategically!',
    position: 'center'
  },
  {
    id: 'tool-cards',
    title: 'Your Favorite Tools',
    description: 'Click any tool card to view full details or launch directly. Remove from collection by clicking the star icon.',
    element: '[data-tour="collection-tools"]',
    position: 'right',
    spotlight: true
  }
];
